export type ScoreVariant = 'good' | 'great' | 'heat' | 'danger' | 'neutral';

/**
 * Stacked floating combat text — NFS/Burnout-style score pops above the action line.
 */
export class FloatingScoreFeed {
  private readonly root: HTMLElement | null;

  constructor() {
    this.root = document.getElementById('score-feed-root');
  }

  /**
   * @param line Primary line (e.g. "+100 NEAR MISS" or "PURSUIT BREAKER")
   * @param sub Optional smaller caption (e.g. heat tier name)
   */
  show(
    line: string,
    sub?: string,
    variant: ScoreVariant = 'good',
    comboLine?: string,
    weight: 'normal' | 'mega' = 'normal',
  ): void {
    if (!this.root) return;

    const el = document.createElement('div');
    el.className = `score-pop score-pop--${variant}${weight === 'mega' ? ' score-pop--mega' : ''}`;
    el.setAttribute('role', 'status');

    const main = document.createElement('span');
    main.className = 'score-pop__line';
    main.textContent = line;

    el.appendChild(main);
    if (sub && sub.length > 0) {
      const s = document.createElement('span');
      s.className = 'score-pop__sub';
      s.textContent = sub;
      el.appendChild(s);
    }
    if (comboLine && comboLine.length > 0) {
      const c = document.createElement('span');
      c.className = 'score-pop__combo';
      c.textContent = comboLine;
      el.appendChild(c);
    }

    this.root.appendChild(el);

    requestAnimationFrame(() => {
      el.classList.add('score-pop--in');
    });

    window.setTimeout(() => {
      el.classList.add('score-pop--out');
      window.setTimeout(() => el.remove(), 500);
    }, 1650);
  }
}
